import { z } from 'zod';

const clientEpisodeSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.enum(['planned', 'waitlist', 'active', 'follow-up', 'on-hold', 'finished']),
  startDate: z.string(),
  endDate: z.string().optional(),
  provider: z.string(),
  careManagerPractitionerId: z.string().optional(),
  groupCohortName: z.string().optional(),
  groupCohortReference: z.string().optional(),
});

/**
 * Minimal validation for `mapPilotPatientToClient` output at the FHIR→UI boundary.
 * Full `Client` has many optional fields; this subset must always be present.
 */
export const mappedCaseloadClientSchema = z.object({
  id: z.string().min(1),
  name: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  preferredFirstName: z.string(),
  preferredLastName: z.string(),
  pronouns: z.string(),
  clientType: z.enum(['Adult', 'Minor']),
  status: z.enum([
    'Active',
    'Inactive',
    'Pending Transfer',
    'Pending Consultation',
    'Discharged',
    'Unresponsive',
    'Follow up',
  ]),
  relationshipType: z.enum(['Primary', 'Coverage', 'IOP', 'Supervisee']),
  firstSession: z.string(),
  mostRecentAppointment: z.string(),
  nextAppointment: z.string(),
  outstandingItems: z.array(z.string()),
  provider: z.string(),
  primaryProvider: z.string(),
  supervisee: z.string().optional(),
  practice: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
  episodes: z.array(clientEpisodeSchema).optional(),
  /** UI may coerce FHIR display text; keep loose at the boundary. */
  serviceType: z.string().optional(),
  dateOfBirth: z.string().optional(),
  /** Derived from the Patient `is-high-risk` extension. */
  highRiskFlags: z.array(z.string()).optional(),
});
